export enum WidgetType {
    PROTO                   = 'proto-widget',

    // Lists
    TASK_LIST               = 'task-list',
    PROJECT_LIST            = 'project-list',
    EVENT_LIST              = 'event-list',

    COUNTER                 = 'counter',
    PASTDUE_TASK_LIST       = 'pastdue-task-list',
    UPCOMING_EVENTS_LIST    = 'upcoming-events-list',
    PROJECT_SUMMARY         = 'project-summary',
    TASKS_SUMMARY           = 'tasks-summary',
    PROJECTS_SUMMARY        = 'projects-summary',
    QUICK_NOTES             = 'quick-notes',
    RICH_TEXT               = 'rich-text',

    BURNDOWN                = 'burndown',
    BURNUP                  = 'burnup',
    VELOCITY                = 'velocity',
    CUMULATIVE_FLOW         = 'cumulative-flow',
    CYCLE_TIME              = 'cycle-time',
    LEAD_TIME               = 'lead-time',

    EMBED                   = 'embed',


    // Charts
    TASK_CHART               = 'task-chart',
    PROJECT_CHART            = 'project-chart',
    TASK_LIFECYCLE_CHART     = 'task-lifecycle-chart',

    BAR_CHART               = 'bar-chart',
    PIE_CHART               = 'pie-chart',
    LINE_CHART              = 'line-chart',
    REAL_TIME_LINE_CHART    = 'real-time-line-chart',
    LOLLIPOP_CHART          = 'lollipop-chart',
    BATTERY_CHART           = 'battery-chart',

    TIME_REPORTS_SUMMARY    = 'time-reports-summary',
    TIME_REPORT             = 'time-report',
    TIME_REPORTED_BY_DAY    = 'time-reported-by-day',


    // TIME
    COUNTDOWN               = 'countdown',
    CLOCK                   = 'clock',
    TIMER                   = 'timer',

    // PROFILE
    PROFILE_USER            = 'profile-user',
    PROFILE_PROJECT         = 'profile-project',

}
